"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeClasses = void 0;
var mergeClasses = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.filter(function (x) { return x; }).join(' ');
};
exports.mergeClasses = mergeClasses;
